import { Card } from 'antd'
import React from 'react'

const Home = () => {
  return (
    <Card style={{ height: "100%", overflow: "auto" }}>
      Home
    </Card>
  )
}

export default Home